import { UniversalFilterConfig } from "../../components/Filters/ReportFilter";

/**
 * 📦 Movimientos de Inventario
 *
 * Backend esperado: branchId, dateFrom, dateTo
 */
export const inventoryMovementReportFilters: UniversalFilterConfig[] = [
  {
    name: "branchId",
    label: "Sucursal",
    type: "select",
    iconKey: "branch",
  },
  {
    name: "dateFrom",
    label: "Fecha Desde",
    type: "date",
    iconKey: "calendar",
  },
  {
    name: "dateTo",
    label: "Fecha Hasta",
    type: "date",
    iconKey: "calendar",
  },
];
